import { render, staticRenderFns } from "./ProductCoatingFields.vue?vue&type=template&id=58fe2100&"
import script from "./ProductCoatingFields.vue?vue&type=script&lang=js&"
export * from "./ProductCoatingFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports